import {Component, Input, OnInit } from '@angular/core';
import {AppService} from 'src/app/app.service';
import {CoreModule} from "../../_core/core.module";

@Component({
	selector: 'app-offer-marketing',
	standalone: true,
	imports: [
		CoreModule
	],
	templateUrl: './offer-marketing.component.html',
	styleUrl: './offer-marketing.component.scss'
})
export class OfferMarketingComponent implements OnInit	 {
	@Input() public mode: any;
	@Input() public offer: any;
	@Input() $storage!: any;

	counter: number;
	constructor(
		public appService: AppService,
	) {
	}

	ngOnInit(): void {
		this.counter = this.$storage.order?.offerCounters[this.offer?.offer];
	}
}
